import { getTime } from 'date-fns';
import { useQuery } from '@tanstack/react-query';
import { getServerUrl } from '../../universal-nav/utils/getServerUrl';
import { useUniversalNavContext } from './useUniversalNavContext';

// Possible treatments for the task usage in Home experiment
// Epic: https://zapierorg.atlassian.net/browse/EPOE-1579
export type SplitTreatment = 'ineligible' | 'off' | 'on';

export const useQueryTaskUsageTreatment = (
  email: string | undefined,
  customUserId: number | undefined,
  signupDate: string | undefined
) => {
  const { bffHostname } = useUniversalNavContext();
  const serverUrl = getServerUrl(bffHostname);

  const result = useQuery({
    queryKey: ['task-usage-treatment'],
    queryFn: async () => {
      const url = new URL(
        '/task-usage-experiment/treatment',
        serverUrl || window.location.origin
      );

      const signup = getTime(signupDate || 0);
      const params = new URLSearchParams({
        email: email || '',
        id: customUserId?.toString() || '',
        signup: signup.toString(),
      });

      url.search = params.toString();

      const response = await fetch(url.toString(), {
        credentials:
          process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const resultTreatment = await response.json();
      return resultTreatment.data?.treatment as SplitTreatment;
    },
    enabled: !!email && !!customUserId && !!signupDate,
  });

  return {
    ...result,
    isLoading: result.isInitialLoading,
  };
};
